import { render, staticRenderFns } from "./PageLimitSelector.vue?vue&type=template&id=3868c2e8&scoped=true&"
import script from "./PageLimitSelector.vue?vue&type=script&lang=js&"
export * from "./PageLimitSelector.vue?vue&type=script&lang=js&"
import style0 from "./PageLimitSelector.vue?vue&type=style&index=0&id=3868c2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868c2e8",
  null
  
)

export default component.exports